import React, { useState, useEffect } from 'react';
import { Card, Form, Button, Row, Col, Spinner, Alert, Image } from 'react-bootstrap';
import { useEntidadeContext } from '../../EntidadeContext';
import { useAlertModal } from '../../AlertModalContext';
import axios from 'axios';
import config from '../../config';

const LayoutEntidadeTab = () => {
    const { currentEntidade, setCurrentEntidade } = useEntidadeContext();
    const { showAlertModal } = useAlertModal();

    const [selectedFile, setSelectedFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    // Efeito para limpar o preview quando o arquivo é removido ou o componente é desmontado
    useEffect(() => {
        if (!selectedFile) {
            setPreview(undefined);
            return;
        }
        const objectUrl = URL.createObjectURL(selectedFile);
        setPreview(objectUrl);

        // Limpeza: revoga a URL do objeto para evitar vazamentos de memória
        return () => URL.revokeObjectURL(objectUrl);
    }, [selectedFile]);

    const handleFileChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            setSelectedFile(e.target.files[0]);
            setError(null); // Limpa erros anteriores ao selecionar um novo arquivo
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedFile) {
            setError('Por favor, selecione um arquivo de imagem para o logo.');
            return;
        }
        if (!currentEntidade) {
            setError('Nenhuma entidade selecionada.');
            return;
        }

        setIsLoading(true);
        setError(null);

        const formData = new FormData();
        formData.append('logo', selectedFile);

        try {
            const response = await axios.post(`/api/entidades/${currentEntidade.id}/upload-logo`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            // Atualiza o contexto da entidade com os novos dados (incluindo a nova logo_url)
            setCurrentEntidade(response.data.entidade);
            showAlertModal('Sucesso', 'Logo atualizado com sucesso!', 'success');
            setSelectedFile(null); // Limpa a seleção após o envio

        } catch (err) {
            const apiError = err.response?.data?.message || 'Ocorreu um erro ao enviar o logo.';
            setError(apiError);
            showAlertModal('Erro', apiError, 'danger');
        } finally {
            setIsLoading(false);
        }
    };

    // A API do backend (através do accessor 'logo_url' no Model Entidade) 
    // já retorna a URL completa. Não é necessário concatenar com a URL base da API.
    const currentLogoUrl = currentEntidade?.logo_url || null;

    return (
        <Card>
            <Card.Header>
                <Card.Title>Logo para E-mails e Documentos</Card.Title>
            </Card.Header>
            <Card.Body>
                <Form onSubmit={handleSubmit}>
                    <Row className="align-items-center">
                        <Col md={4} className="text-center mb-3 mb-md-0">
                            <h6>Logo Atual</h6>
                            <Image 
                                src={preview || currentLogoUrl || 'https://via.placeholder.com/150x100?text=Sem+Logo'} 
                                thumbnail 
                                style={{ maxHeight: '100px', width: 'auto' }}
                            />
                        </Col>
                        <Col md={8}>
                            <Form.Group controlId="formFile" className="mb-3">
                                <Form.Label>Selecione um novo logo (PNG, JPG, GIF)</Form.Label>
                                <Form.Control type="file" onChange={handleFileChange} accept="image/png, image/jpeg, image/gif" />
                            </Form.Group>
                            {error && <Alert variant="danger">{error}</Alert>}
                            <div className="d-flex justify-content-end">
                                <Button variant="primary" type="submit" disabled={isLoading || !selectedFile}>
                                    {isLoading ? <><Spinner as="span" animation="border" size="sm" /> Salvando...</> : 'Salvar Novo Logo'}
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </Form>
            </Card.Body>
        </Card>
    );
};

export default LayoutEntidadeTab;